import React,{ReactNode, useState} from "react";
import SubscriptionDisclaimer from "../SubscriptionDisclaimer/SubscriptionDisclaimer";
import OtherOrders from "../OtherOrders/OtherOrders";
import {useParams} from "react-router-dom";
import "./MyAccountContentHeader.css";
import * as translator from '../../../../utils/translator';
import * as http from "../../../../utils/http";
import InnerHTMLRenderer from "../../../../components/InnerHTMLRenderer/InnerHTMLRenderer";


interface MyAccountContentHeaderProps{
  title:string;
  titleFurnish?:ReactNode;
  description?:string;
  showPrintOptionInDescription?:boolean
  showOtherOrders?:boolean //Shows the other orders in different country
  otherCountriesOrders?: { [key: string]: { count: number; language: string } };
  otherOrdersCount?:number;
  country?:any;
  showSubscriptionDisclaimer?:boolean
  descriptionClass?: string
  titleClass?: string
}


/*
   Header may contain OtherOrders & SubscriptionDisclaimer like in my-orders section (comes from props)
*/
const MyAccountContentHeader: React.FC<MyAccountContentHeaderProps> = ({title, titleFurnish,description,showPrintOptionInDescription=false,showOtherOrders=false,otherCountriesOrders,otherOrdersCount,showSubscriptionDisclaimer=false, descriptionClass="", titleClass=""}) => {

  const [isLoadingPdf,setIsLoadingPdf] = useState<boolean>(false);
  const {country} = useParams();
  const language = translator.getLanguageByCountry(country)

  const getOrdersPdf = () => {
    setIsLoadingPdf(true)
    http
      .getFromServer(`${country}/account/orders/pdf`,
       [http.MIDDLEWARES.CUSTOMER_ID, http.MIDDLEWARES.GENERATE_FILE])
      .then((response:any) => {
        const url = window.URL.createObjectURL(new Blob([response.data],{type:"application/pdf"}));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'orders.pdf'); // replace with desired filename
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      })
      .catch((error:any) => {
          window.clientLogger.error("Failed to get pdf with error: ", error)
      })
      .finally(() => setIsLoadingPdf(false));
      
  };

  return (
    <div className="account-content-header">
      <p className={`${titleClass ? titleClass : "account-content-header-title"}`}>
        {title}
        {titleFurnish}     
      </p>
      {(description || showPrintOptionInDescription) && (
        <InnerHTMLRenderer className={`account-content-header-description ${descriptionClass}`} htmlContent={description || ''} >
          {showPrintOptionInDescription ?

            isLoadingPdf ?

              <div className="loader-2 center"><span></span></div>

              :

              <span onClick={getOrdersPdf} >
                {translator.translate(language, "my_account", 'MyOrders/print')}
              </span>

            :
            null
          }
        </InnerHTMLRenderer>
      )}
      {otherCountriesOrders && Object.keys(otherCountriesOrders).map(key => (
        <OtherOrders key={key} language={language} otherCountry={key.toLowerCase()} otherOrdersCount={otherCountriesOrders[key].count} otherCountryLanguage={otherCountriesOrders[key].language}/>
      ))}

      {/* Subscription Disclaimer Section */
      showSubscriptionDisclaimer ? <SubscriptionDisclaimer country={country!} language={language}/> : null
      }

    </div>
  );
};

export default MyAccountContentHeader;
